import {
  LOGIN_BUTTON_REQUEST,
  LOGIN_BUTTON_SUCCESS,
  LOGIN_BUTTON_ERROR,
  PHONE_NUMBER_REQUEST,
  RESET_LOGIN_VALUE,
  DO_LOGIN,
  DO_LOGIN_SUCCESS,
  DO_LOGIN_ERROR,
  GET_REFERRAL_CODE,
  IS_REFERAL_MODAL,
  GET_REFERRAL_CODE_PENDING,
  GET_REFERRAL_CODE_SUCCESS,
  GET_REFERRAL_CODE_ERROR,
  CHECK_MOBILE_FIELD_FOCUS,
  GET_USER_STATUS_REQUEST_ERROR,
  GET_USER_STATUS_REQUEST_SUCCESS,
  GET_USER_STATUS_REQUEST,
  GET_LDC_REQUEST,
  GET_LDC_SUCCESS,
  GET_LDC_ERROR,
  CONFIRM_OTP_REQUEST,
  CONFIRM_OTP_SUCCESS,
  CONFIRM_OTP_ERROR,
  CHECK_KYC_STATUS,
  HANDLE_CHECKBOX,
  GET_PORTFOLIO_REQ,
  GET_PORTFOLIO_ERROR,
  GET_PORTFOLIO_SUCCESS,
  GET_CUSTOMER_DETAILS,
  GET_CUSTOMER_DETAILS_SUCCESS,
  GET_CUSTOMER_DETAILS_ERROR

} from "../../actionType";

export const getPhoneNumber = (value: any) => ({
  type: PHONE_NUMBER_REQUEST,
  value,
});

export const getLoginRequest = () => ({
  type: LOGIN_BUTTON_REQUEST,
});

export const getLoginSuccess = (status: boolean) => ({
  type: LOGIN_BUTTON_SUCCESS,
  status,
});

export const getLoginError = (error: any) => ({
  type: LOGIN_BUTTON_ERROR,
  error,
});

export const resetValue = () => ({
  type: RESET_LOGIN_VALUE,
});

export const doLogin = (loginDetails: object) => ({
  type: DO_LOGIN,
  loginDetails,
});

export const doLoginSuccess = (data:any) => ({
  type: DO_LOGIN_SUCCESS,
  data,
});

export const doLoginError = (error: string) => ({
  type: DO_LOGIN_ERROR,
  error,
});

export const getReferralCode = (referralCode: string | null) => ({
  type: GET_REFERRAL_CODE,
  referralCode,
});
export const isReferalModal = () => ({
  type: IS_REFERAL_MODAL,
});
export const getReferralPending = () => ({
  type: GET_REFERRAL_CODE_PENDING,
});

export const referralCodeSuccess = (data: any) => ({
  type: GET_REFERRAL_CODE_SUCCESS,
  data,
});

export const referralCodeError = (error: any) => ({
  type: GET_REFERRAL_CODE_ERROR,
  error,
});
export const checkMobileFieldFocus = (isFocus: boolean) => ({
  type: CHECK_MOBILE_FIELD_FOCUS,
  isFocus,
});
// USER INFO 
export const getUserRequest = () => ({
  type: GET_USER_STATUS_REQUEST,
});

export const getUserRequestSuccess = (data: any) => ({
  type: GET_USER_STATUS_REQUEST_SUCCESS,
  data,
});

export const getUserRequestError = (error: any) => ({
  type: GET_USER_STATUS_REQUEST_ERROR,
  error,
});

// LDC OTP
export const getLDCRequest = () => ({
  type: GET_LDC_REQUEST
});

export const getLDCSuccess = (data: any) => ({
  type: GET_LDC_SUCCESS,
  data
});

export const getLDCError = (error: any) => ({
  type: GET_LDC_ERROR,
  error
});

export const confirmOTPRequest = (value: any) => ({
  type: CONFIRM_OTP_REQUEST,
  value
});
export const confirmOTPSuccess = (data: any) => ({
  type: CONFIRM_OTP_SUCCESS,
  data
});
export const confirmOTPError = (error: any) => ({
  type: CONFIRM_OTP_ERROR,
  error
});

export const checkCkycStatus = (data: any) => ({
  type: CHECK_KYC_STATUS,
  data
});

export const onChangeCheckbox = (data: any) => ({
  type: HANDLE_CHECKBOX,
  data
});

export const getPortFolioReq = () => ({
  type: GET_PORTFOLIO_REQ,
});

export const getPortFolioError = (error: any) => ({
  type: GET_PORTFOLIO_ERROR,
  error
});

export const getPortFolioSuccess = (data: any) => ({
  type: GET_PORTFOLIO_SUCCESS,
  data
});

export const getCustomerDetails = (pageNumber:number) => ({
  type: GET_CUSTOMER_DETAILS,
  pageNumber
});

export const getCustomerDetailsError = (error: any) => ({
  type: GET_CUSTOMER_DETAILS_ERROR,
  error
});

export const getCustomerDetailsSuccess = (data: any) => ({
  type: GET_CUSTOMER_DETAILS_SUCCESS,
  data
});